import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usePageHeader } from '../../providers/PageHeaderProvider';
import { usePageTitle } from '../../hooks/usePageTitle';
import { InvoicesContent } from '../../components/billing/invoices/InvoicesContent';

const STATUS_FILTER_STORAGE_KEY = 'fv_billing_invoiceStatusFilter';
const PRACTICE_FILTER_STORAGE_KEY = 'fv_billing_invoicePracticeFilter';

export function InvoicesList() {
    usePageTitle('Invoices');
    const { setTitle, setSubtitle } = usePageHeader();
    const navigate = useNavigate();
    // The open invoice drawer is URL-driven, so links are shareable and the
    // browser back button restores it.
    const { invoiceId } = useParams<{ invoiceId: string }>();
    const [totalCount, setTotalCount] = useState(0);

    useEffect(() => {
        setTitle('Invoices');
        setSubtitle(`${totalCount} total`);
        return () => {
            setTitle(null);
            setSubtitle(null);
        };
    }, [totalCount, setTitle, setSubtitle]);

    return (
        <InvoicesContent
            openInvoiceId={invoiceId ?? null}
            onOpenInvoice={(id) => navigate(`/billing/invoices/${id}`)}
            onCloseInvoice={() => navigate('/billing/invoices')}
            statusFilterStorageKey={STATUS_FILTER_STORAGE_KEY}
            practiceFilterStorageKey={PRACTICE_FILTER_STORAGE_KEY}
            onTotalCountChange={setTotalCount}
        />
    );
}
